import { Col } from 'components/base';
import type React from 'react';
import type { PropsWithChildren } from 'react';

export const Body: React.FC<PropsWithChildren> = ({ children }) => (
  <Col>{children}</Col>
);
